import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Unauthenticated from 'Components/ComponentLibrary/Templates/Unauthenticated';
import Content from './Content';

const styles = () => ({
  root: {},
  leftSide: {},
});

const SetNewPassword = ({
  className,
  classes,
}) => {
  return (
    <Unauthenticated
      className={classNames(classes.root, className)}
    >
      <Content className={classes.leftSide} />
    </Unauthenticated>
  );
};

SetNewPassword.defaultProps = {
  className: '',
};

SetNewPassword.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SetNewPassword);
